<template>
	<div class="editable-wrapper" :class="{ 'editable-area': editable }" @click="handleClick" ref="editableContainer">
		<Transition name="editor-pop" appear>
			<div v-if="isEditing" class="editor-container">
				<div class="editing-label">{{ editLabel }}</div>
				<div class="inline-editor-wrapper">
					<TipTapEditor
						ref="editInput"
						v-model="editedValue"
						@onEscape="cancelEdit"
						@onEnter="handleEnter"
						class="inline-editor__input"
						@click.stop
						@getAISuggestion="handleGetAISuggestion"
						@acceptAISuggestion="handleAcceptAISuggestion"
						:editorStyles="{ 'max-height': '60vh', overflow: 'hidden' }"
						showVideoEmbed
						extended
						showGenerateWithAI
					/>
				</div>
			</div>
		</Transition>

		<slot></slot>
		<div class="popup-backdrop" ref="modalBackdrop" v-if="isEditing" @click="saveEdit"></div>
	</div>
</template>

<script>
	import TipTapEditor from '~/components/shared/TipTapEditor'

	export default {
		name: 'EditableComponent',
		components: { TipTapEditor },
		props: {
			editable: {
				type: Boolean,
				default: false,
			},
			value: {
				type: String,
				default: '',
			},
			editLabel: {
				type: String,
				default: 'Edit',
			},
		},
		data() {
			return {
				isEditing: false,
				editedValue: this.value,
			}
		},

		watch: {
			value(newValue) {
				this.editedValue = newValue
			},
		},
		methods: {
			handleClick(event) {
				if (!this.editable || this.isEditing) return

				event.preventDefault()
				event.stopPropagation()

				this.$emit('opened')

				this.editedValue = this.value
				this.isEditing = true

				// Focus the input after it's been rendered
				this.$nextTick(() => {
					if (this.$refs.editInput) {
						this.$refs.editInput.focusEditor()
						setTimeout(() => {
							this.$refs.editInput.scrollIntoView()
						}, 200)
					}
				})
			},

			handleEnter(event) {
				if (event.shiftKey) {
					return
				}
				event.preventDefault()
				this.saveEdit()
			},
			saveEdit(e) {
				const trimmedVal = this.editedValue.trim()
				if (trimmedVal !== '') {
					this.$emit('input', trimmedVal)
					this.$emit('change', trimmedVal)
				}
				e.stopPropagation()
				this.isEditing = false
			},
			cancelEdit() {
				this.editedValue = this.value
				this.isEditing = false
			},
			handleGetAISuggestion(prompt) {
				this.$emit('getAISuggestion', prompt)
			},
			handleAcceptAISuggestion() {
				this.$emit('acceptAISuggestion')
			},
		},
	}
</script>

<style scoped lang="scss">
	.editable-wrapper {
		position: relative;
		width: 100%;
		min-height: 1em;
		height: fit-content;
		overflow: visible;
		display: flex;
	}

	.editable-area {
		cursor: pointer;
	}

	.editing-label {
		position: absolute;
		top: -22px;
		left: 2px;
		background-color: var(--stan-primary-primary-color);
		color: white;
		font-size: 12px;
		padding: 2px 6px;
		border-radius: 4px;
		pointer-events: none;
		z-index: 2;
		font-weight: 500;
		line-height: 16px;
		font-family: 'Inter';
	}
	.editable-area:hover .label-overlay {
		display: block;
	}

	.editor-container {
		position: absolute;
		top: -30px;
		width: 100%;
		height: fit-content;
		z-index: 3;
	}

	.inline-editor-wrapper {
		position: relative;
		z-index: 3;
		width: 100%;
		height: fit-content;
	}

	.inline-editor__input {
		border-radius: 8px;
		border: 2px solid var(--stan-primary-primary-color);
		background: white;
		filter: drop-shadow(-5px 5px 20px#00000060);
		font-size: inherit;
		font-family: inherit;
		color: var(--stan-text-dark-color);
		&:focus-visible {
			outline: none;
		}
	}

	.edit-label {
		position: absolute;
		top: -24px;
		left: 0;
		background-color: var(--stan-primary-primary-color);
		color: white;
		padding: 2px 6px;
		font-size: 10px;
		border-radius: 3px 3px 0 0;
		z-index: 2;
		pointer-events: none;
	}

	.editor-pop-enter-active,
	.editor-pop-leave-active {
		transition: opacity 0.3s ease, transform 0.3s ease;
	}

	.editor-pop-enter,
	.editor-pop-leave-to {
		opacity: 0;
		transform: scale(0.98);
		transform-origin: top left;
	}
	.popup-backdrop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		opacity: 0;
		transition: opacity 0.3s ease;
		z-index: 2;
	}
</style>
